import { Component, AfterViewInit } from "@angular/core";
import { Input } from "@angular/core";
import { ElementRef } from "@angular/core";
import { ViewChild } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { OnInit } from "@angular/core";
import { NgZone } from "@angular/core";
import { YouTubeService } from "@app/services/youtube.service";

declare var YT: any;
@Component({
  selector: "youtube-playlist",
  templateUrl: "./youtube-playlist.component.html",
})
export class YouTubePlaylistComponent implements OnInit {
  @Input()
  playlistId: string;
  playlistUrl: SafeResourceUrl;
  @ViewChild("playerElement")
  playerElementRef: ElementRef;
  done = false;
  player;
  videosInfo: any[] = [];
  videos: any[];
  selectedVideo: any;

  @Input()
  filter: string;

  constructor(
    private sanitizer: DomSanitizer,
    private zone: NgZone,
    private youtubeService: YouTubeService
  ) {}

  ngOnInit(): void {
    this.youtubeService.getPlaylist(this.playlistId).then((playlist) => {
      console.log(playlist);
      playlist
        .getVideos()
        .then((videos) => {
          this.videos = videos;
        })
        .catch(console.log);
    });
  }

  playVideo(video) {
    this.selectedVideo = video;
  }

  removeLink(description) {
    return description.replace(/Try our.*/, "");
  }

  getVideoUrl(video): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube.com/embed/${video.id}?&autoplay=1`
    );
  }

  containsFilter(video, filter: string): boolean {
    return (
      video.title.toLowerCase().indexOf(filter.toLowerCase()) > -1 ||
      video.description.toLowerCase().indexOf(filter.toLowerCase()) > -1
    );
  }
}
